import type { ReactNode } from "react";

const hasOwnProperty = (obj: ReactNode | object, property: string): boolean => {
  return Object.prototype.hasOwnProperty.call(obj, property);
};

const hasChildren = (node: object): boolean => {
  return hasOwnProperty(node, "children");
};

const hasProps = (node: ReactNode): boolean => {
  return hasOwnProperty(node, "props");
};

const reduceNodeToString = (previous: string, current: ReactNode): string => {
  return previous.length
    ? `${previous} ${innerText(current)}`
    : innerText(current);
};

export const innerText = (node: ReactNode): string => {
  if (
    node === null ||
    typeof node === "undefined" ||
    typeof node === "boolean"
  ) {
    return "";
  } else if (typeof node === "string") {
    return node;
  } else if (typeof node === "number") {
    return node.toString();
  } else if (Array.isArray(node)) {
    return (node as React.ReactNodeArray).reduce<string>(
      reduceNodeToString,
      ""
    );
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - hasProps checks for props, but may be able to fix this
  } else if (hasProps(node) && hasChildren(node.props)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - how can we make sure ts knows this is ok?
    return innerText(node.props.children);
  }

  return "";
};
